import { useQuery } from '@tanstack/react-query';
import { getIFrameIntegrationViewerDetails } from 'api/services';

const useIFrameIntegrationViewerData = (token: string) => {
    const iFrameIntegrationViewerQuery = useQuery(
        ['iframeIntegrationViewer', token],
        () => getIFrameIntegrationViewerDetails(token),
        { enabled: Boolean(token) }
    );

    return {
        isLoading: iFrameIntegrationViewerQuery.isLoading,
        error: iFrameIntegrationViewerQuery.error,
        camera: iFrameIntegrationViewerQuery.data?.camera,
        project: iFrameIntegrationViewerQuery.data?.project,
        integration: iFrameIntegrationViewerQuery.data?.integration,
    };
};

export default useIFrameIntegrationViewerData;
